import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { TransportService } from "service/TransportService";
import { TRANSPORT } from "helpers/routes";

import TablesConstructor, { TRANSPORT_TYPE } from "components/Tables/TablesConstructor";
import LoadingType from "components/Tables/LoadingType";
import RoutesTableData from "components/Tables/RoutesTableData";
import TransportBodyType from "components/Tables/TransportBodyType";
import ExchangeInfo from "components/TransportComponents/ExchangeInfo";
import AvailableDateData from "components/Tables/AvailableDateData";
import PublicationDateData from "components/Tables/PublicationDateData";
import ContactsTableData from "components/Tables/ContactsTableData";
import StatusTableData from "components/Tables/StatusTableData";

export default function TransportTable({ data, withItemsCount = false, updateData, selectedId, onSelect, showStatusColumn = false, isLoading = false, showAddButton = true }) {
  console.log('data', data);
    const { t } = useTranslation();
    const authenticated = useSelector((state) => state.auth.authenticated);

    const labels = useMemo(
      () =>
        [
          ...(showStatusColumn ? [{
            name: 'status',
            label: t('cargo.allTable.status'),
            data: ['status'],
            component: StatusTableData,
          }] : []),
          {
            name: 'route_loading',
            label: t('transport.table.upload'),
            data: ['loading_address'],
            component: RoutesTableData,
          },
          {
            name: 'route_unloading',
            label: t('transport.table.unload'),
            data: ['unloading_address'],
            component: RoutesTableData,
          },
          {
            name: 'available_dates',
            label: t('transport.table.date'),
            data: ['available_from', 'available_to', 'isExpired'],
            component: AvailableDateData,
          },
          {
            name: 'body_type',
            label: t('transport.table.bodyTypeShort'),
            data: [
              'transport_bodytypes',
              'transport_bodytype_additional',
              'transport_exchanges_adr_captions',
              'transport_exchanges_adr_items',
              'carrying_capacity',
              'length',
              'width',
              'height',
              'volume',
              'route_distance_meters',
            ],
            component: TransportBodyType,
          },
          {
            name: 'loading_type',
            label: t('transport.table.loadingType'),
            data: ['loading_types', 'conics', 'gidrolift'],
            component: LoadingType,
          },
          {
            name: 'publication_date',
            label: t('transport.table.publicationDate'),
            data: ['created_at', 'last_up_to_top_at'],
            component: PublicationDateData,
          },
          ...(authenticated
            ? [
                {
                  name: 'contacts',
                  label: t('transport.table.contact'),
                  data: ['user', 'company_name', 'photo', 'company_logo_url_small', 'company_logo_url', 'ratings', 'paymentsSummary'],
                  component: (props) => <ContactsTableData url={TRANSPORT.getContacts} {...props} />,
                  topAlign: true,
                },
              ]
            : []),
        ].filter(Boolean),
      [t, authenticated, showStatusColumn],
    );

    return (
        <>
            <TablesConstructor
                data={data}
                labels={labels}
                resultsCountShow={withItemsCount && data.count}
                InfoComponent={ExchangeInfo}
                service={TransportService}
                updateData={updateData}
                noDataMessage={t("myTransport.no_items")}
                urlToAdd={TRANSPORT.addToExchange}
                type={TRANSPORT_TYPE}
                selectedId={selectedId}
                onSelect={onSelect}
                isLoading={isLoading}
                showAddButton={showAddButton}
            />
        </>
    );
}
